import axios from "axios";
import { auth } from "../../../firebaseConfig";
import { Capacitor, CapacitorHttp } from "@capacitor/core";
import { backendApiURL } from "../../../common/apiService";

export interface ImageSearchResponse {
    hits: ImageHit[],
}

interface ImageHit {
    id: number,
    webformatURL: string,
    largeImageURL: string,
    previewURL: string,
    tags: string,
}

export function imagesSearch(text: string, language?: "it" | "en"): Promise<string[]> {
    return new Promise<string[]>((resolve, reject) => {
        auth.currentUser?.getIdToken()
            .then(async token => {
                const requestData = {
                    text: text,
                    lang: language ? language : "it"
                };

                const apiUrl = `${backendApiURL}/imageSearch`;

                // Try axios first (works on web and Android)
                if (Capacitor.getPlatform() === 'web' || Capacitor.getPlatform() === 'android') {
                    try {
                        console.log('[imageSearch] Using axios for', Capacitor.getPlatform());
                        const response = await axios.post(apiUrl, requestData, {
                            headers: {
                                "Authorization": `Bearer ${token}`,
                                'Content-Type': 'application/json'
                            },
                            timeout: 10000 // 10 second timeout
                        });
                        
                        console.log('[imageSearch] axios response:', response.data);
                        resolve(response.data);
                        return;
                    } catch (error) {
                        console.warn('[imageSearch] axios failed, falling back to Capacitor HTTP:', error);
                        // Fall through to Capacitor HTTP
                    }
                }

                // Use Capacitor HTTP (for iOS or as fallback)
                try {
                    console.log('[imageSearch] Using Capacitor HTTP for', Capacitor.getPlatform());
                    const options = {
                        url: apiUrl,
                        headers: {
                            "Authorization": `Bearer ${token}`,
                            'Content-Type': 'application/json',
                        },
                        data: requestData
                    };

                    const response = await CapacitorHttp.post(options);
                    console.log('[imageSearch] Capacitor HTTP response:', response.data);
                    resolve(response.data);
                } catch (capacitorError) {
                    console.error('[imageSearch] Capacitor HTTP error:', capacitorError);
                    reject(capacitorError);
                }
            })
            .catch(authError => {
                console.error('[imageSearch] Auth error:', authError);
                reject(authError);
            });
    });
}
